import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const MIN_LIST_CHIP_FILTERS_CONTAINER_WIDTH = 240;

export const StyledInputBox = styled(Box)`
  margin: ${({ theme }) => theme.spacing(1, 0, 1, 0)};
`;

export const StyledBox = styled(Box)`
  min-width: ${MIN_LIST_CHIP_FILTERS_CONTAINER_WIDTH}px;
  padding: ${({ theme }) => theme.spacing(1)};
`;
